import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Video, Mic, MicOff, VideoOff, PhoneOff } from 'lucide-react';
import { professionals } from '../data/mockData';
export function VideoWaitingScreen() {
  const navigate = useNavigate();
  const professional = professionals[0];
  const [micOn, setMicOn] = useState(true);
  const [videoOn, setVideoOn] = useState(true);
  useEffect(() => {
    // Simulate doctor joining after 3 seconds
    const timer = setTimeout(() => {
      navigate('/video-call');
    }, 3000);
    return () => clearTimeout(timer);
  }, [navigate]);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="flex flex-col min-h-screen bg-slate-900 text-white relative" data-id="element-1799">
      <div className="absolute top-0 left-0 right-0 p-6 z-10 flex items-center justify-between" data-id="element-1800">
        <button onClick={() => navigate(-1)} className="p-2 bg-white/10 hover:bg-white/20 rounded-full backdrop-blur-sm transition-colors" data-id="element-1801">
          <ArrowLeft className="w-6 h-6 text-white" data-id="element-1802" />
        </button>
      </div>

      <div className="flex-1 flex flex-col items-center justify-center p-6 text-center" data-id="element-1803">
        <div className="relative mb-8" data-id="element-1804">
          <motion.div animate={{
          scale: [1, 1.1, 1]
        }} transition={{
          repeat: Infinity,
          duration: 2
        }} className="absolute inset-0 bg-blue-500/20 rounded-full blur-xl" data-id="element-1805" />
          <img src={professional.image} alt={professional.name} className="w-32 h-32 rounded-full object-cover border-4 border-slate-800 relative z-10" data-id="element-1806" />
        </div>

        <h2 className="text-2xl font-bold mb-2" data-id="element-1807">
          Waiting for {professional.name}...
        </h2>
        <p className="text-slate-400 mb-8" data-id="element-1808">
          Connecting securely to consultation room
        </p>

        <div className="bg-slate-800/50 backdrop-blur-md border border-slate-700 p-4 rounded-2xl w-full max-w-xs mb-12" data-id="element-1809">
          <div className="flex justify-between items-center mb-2" data-id="element-1810">
            <span className="text-sm text-slate-400" data-id="element-1811">Appointment Type</span>
            <span className="text-sm font-medium" data-id="element-1812">Video Consult</span>
          </div>
          <div className="flex justify-between items-center" data-id="element-1813">
            <span className="text-sm text-slate-400" data-id="element-1814">Time</span>
            <span className="text-sm font-medium" data-id="element-1815">Today, 2:00 PM</span>
          </div>
        </div>
      </div>

      <div className="p-8 bg-slate-800/80 backdrop-blur-lg rounded-t-3xl border-t border-slate-700 flex justify-center gap-6" data-id="element-1816">
        <button onClick={() => setMicOn(!micOn)} className={`w-14 h-14 rounded-full flex items-center justify-center transition-colors ${micOn ? 'bg-slate-700 text-white hover:bg-slate-600' : 'bg-red-500 text-white hover:bg-red-600'}`} data-id="element-1817">
          {micOn ? <Mic className="w-6 h-6" data-id="element-1818" /> : <MicOff className="w-6 h-6" data-id="element-1819" />}
        </button>

        <button onClick={() => setVideoOn(!videoOn)} className={`w-14 h-14 rounded-full flex items-center justify-center transition-colors ${videoOn ? 'bg-slate-700 text-white hover:bg-slate-600' : 'bg-red-500 text-white hover:bg-red-600'}`} data-id="element-1820">
          {videoOn ? <Video className="w-6 h-6" data-id="element-1821" /> : <VideoOff className="w-6 h-6" data-id="element-1822" />}
        </button>

        <button onClick={() => navigate('/appointments')} className="w-14 h-14 rounded-full bg-red-600 text-white flex items-center justify-center hover:bg-red-700 transition-colors" data-id="element-1823">
          <PhoneOff className="w-6 h-6" data-id="element-1824" />
        </button>
      </div>
    </motion.div>;
}